var map = {
	"./Amex.svg": "c6eb",
	"./Cabal.svg": "06a5",
	"./Elo.svg": "a948",
	"./Hipercard.svg": "080d",
	"./Mastercard.svg": "ef72",
	"./Visa.svg": "fef7",
	"./account.svg": "2407",
	"./add_photo copy.svg": "5146",
	"./add_photo.svg": "4eb0",
	"./arrow-right.svg": "50c3",
	"./boleto-icon.svg": "b26d",
	"./boleto-red.svg": "72d5",
	"./boleto.svg": "0a4f",
	"./caixa.svg": "78d1",
	"./cart.svg": "6f5d",
	"./categoria.svg": "bfb3",
	"./catologo.svg": "fb22",
	"./check-parceiro.svg": "6c9e",
	"./check.svg": "f222",
	"./copySolid.svg": "7ef6",
	"./email.svg": "9055",
	"./imp copy.svg": "e119",
	"./imp.svg": "1034",
	"./localizacao.svg": "54ee",
	"./logo-imprimax-mini.svg": "179e",
	"./logo-imprimax.svg": "f8aa",
	"./logo-imprimax2.svg": "8c15",
	"./logo.svg": "9b19",
	"./order.svg": "c93c",
	"./payments.svg": "3566",
	"./phone.svg": "001e",
	"./pix-icon.svg": "7253",
	"./pix-red.svg": "82e5",
	"./pix.svg": "3090",
	"./plus.svg": "8a37",
	"./profile.svg": "b855",
	"./revestimento.svg": "ed43",
	"./sort.svg": "133b",
	"./tela-login-mobile.svg": "ad02",
	"./tela-login.svg": "e779",
	"./user.svg": "0f62",
	"./voltar.svg": "ab0e",
	"./vuetify.svg": "6dff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";